import { useCallback, useMemo } from 'react';
import { Box, HiddenVisually, Inline, Text } from 'braid-design-system';
import type {
  JobViewModelClassification,
  JobViewModelItemPartial,
} from 'src/types/JobViewModel';
import MetaLinkRenderer from '../MetaLinkRenderer/MetaLinkRenderer';

type LabelType = 'classification' | 'subClassification';
type ItemTuple = [LabelType, JobViewModelItemPartial];

interface Props {
  classifications: JobViewModelClassification;
}
const ClassificationLinks = ({ classifications }: Props) => {
  const [parent, child] = useMemo<ItemTuple[]>(() => {
    const items: ItemTuple[] = [];
    if (classifications.subClassification?.name) {
      items.push(['subClassification', classifications.subClassification]);
    }

    items.push(['classification', classifications.classification]);

    return items;
  }, [classifications]);

  const renderItem = useCallback(
    (item: ItemTuple, { isChild = false }: { isChild: boolean }) => {
      if (!item || !item[1]) {
        return null;
      }
      const [label, value] = item;

      return (
        <>
          {isChild && <Box marginLeft="xxsmall" />}
          {Boolean(label) && (
            <HiddenVisually>{`${label}: ${value.name}`}</HiddenVisually>
          )}
          <MetaLinkRenderer
            item={value}
            type={label}
            isChild={isChild}
            shouldUseNormalisedCompanyName
            disabledLink
          />
        </>
      );
    },
    [],
  );

  return (
    <Text size="small">
      <Inline space="none">
        {renderItem(parent, { isChild: false })}
        {renderItem(child, { isChild: true })}
      </Inline>
    </Text>
  );
};

export default ClassificationLinks;
